module.exports = __webpack_public_path__ + "img/damare05.7960e37d.jpg";